import { useState, useEffect, useRef, Suspense, lazy } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Burger from '../../components/Nav/Burger.jsx';
import { GalleryImages } from '../Gallery/GalleryImages.js';
import { getGalleryImages } from '../Gallery/photos.js';
import Spy from '../../Spy.js';

import Section1 from './Section_1.js';

const Section5 = lazy(() => import('./Footer.js'));

const FullSite = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  width: 100vw;
  cursor: default;
`;

const ContainerNavBar = styled.div`
  z-index: 50;
  display: grid;
  grid-template-rows: repeat(1, 1fr);
  position: fixed;
  justify-items: center;
  top: 0;
  right: 0;
  height: 0;
  width: 50vw;
  justify-self: stretch;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    width: 100vw;
    grid-template-columns: 1rem 1rem auto 1rem 80px;
  }
  @media screen and (min-width: 481px) and (max-width: 768px) {
    width: 100vw;
    grid-template-columns: 2.5rem 1vw auto 1vw 100px;
  }
  @media screen and (min-width: 769px) {
    grid-template-columns: 2.5vw 1vw auto 1vw 120px;
  }
`;

function Nodeul() {
  const [playing] = useState(true);
  const [activacion, setActivacion] = useState(false);

  const full = useRef(null);
  const loaderRuned = useSelector((state) => state.loaderRuned.value);
  const galleryVariant = 'Nodeul'; // change to 'alternate' to render a different gallery variant
  const galleryImages = getGalleryImages(galleryVariant);

  // Helper to trigger gallery activation
  const activate = () => {
    if (!activacion) setActivacion(true);
  };

  // Logic for scroll animations and gallery triggering
  useEffect(() => {
    const handleScroll = () => {
      if (!activacion && window.scrollY > 10) setActivacion(true);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('mousemove', activate, { passive: true });
    window.addEventListener('wheel', activate, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', activate);
      window.removeEventListener('wheel', activate);
    };
  }, [activacion]);

  // Track page access
  useEffect(() => {
    Spy('OpenPages', 'NodeulAccess');
  }, []);

  return (
    <>
      <FullSite ref={full} className="FullSite" id="FullSite">
        <Suspense fallback={<div>Loading...</div>}>
          {loaderRuned === 'yes' && (
            <ContainerNavBar id="boton">
              <Burger />
            </ContainerNavBar>
          )}

          <Section1
            playing={playing}
            videoUrl="https://vimeo.com/1189486591"
            headingText="Nodeul Island by Heatherwick Studio."
          />

          {/* Wrapper logic: We keep the gallery in the DOM but hidden.
            This prevents the browser from recalculating the page height from 
            scratch when you scroll, which causes the jump to top.
          */}
          <div
            style={{
              display: activacion ? 'block' : 'none',
              opacity: activacion ? 1 : 0,
            }}
          >
            <GalleryImages images={galleryImages} className="fade-in-section" />
            <Section5 className="fade-in-section" />
          </div>
        </Suspense>
      </FullSite>
    </>
  );
}

export default Nodeul;
